import React from 'react';
import Icon from '@components/Icon';
import { goBack } from '@utils';
import './style.scss';

const BackBtn = () => (
  <div className='back-btn' onClick={goBack}>
    <Icon type='arrow-left' />
  </div>
);

export default BackBtn;
